<template>
    <div>
        <a>{{ $t("titles.report") }}</a>
        <img src="./../assets/pictures/report.png" style="max-width:100%;">
    </div>
</template>

<script>
    export default {
        name: "Report"
    }
</script>

<style scoped>

</style> 


// WEBPACK FOOTER //
// src/pages/Report.vue